import { jsxs, jsx } from 'react/jsx-runtime';
import { useCallback, useEffect } from 'react';
import '../../assets/icons/arrowDown.svg.mjs';
import '../Button/index.mjs';
import '../StyleableSvgImage/index.mjs';
import { Wrap, Overlay, InnerWrap, TopCloseWrap, ContentWrap, BottomCloseWrap } from './MobileModal.styles.mjs';
import { StyleableSvgImage } from '../StyleableSvgImage/StyleableSvgImage.mjs';
import ArrowDownIcon__default from "../../assets/arrowDown.svg";
import { Button } from '../Button/Button.mjs';
"use strict";
const MobileModal = function MobileModal2({
  isOpen,
  handleClose,
  lockScroll,
  children,
  closeButtonProps
}) {
  const handleOnAfterOpen = useCallback(() => {
    if (lockScroll) {
      document.body.style.overflow = "hidden";
    }
  }, [lockScroll]);
  const handleOnAfterClose = useCallback(() => {
    if (lockScroll) {
      document.body.style.overflow = "unset";
    }
  }, [lockScroll]);
  useEffect(() => {
    if (isOpen) {
      handleOnAfterOpen();
    } else if (!isOpen) {
      handleOnAfterClose();
    }
    return handleOnAfterClose;
  }, [handleOnAfterClose, handleOnAfterOpen, isOpen]);
  return /* @__PURE__ */jsxs(Wrap, {
    $isOpen: isOpen,
    children: [/* @__PURE__ */jsx(Overlay, {
      onClick: handleClose
    }), /* @__PURE__ */jsxs(InnerWrap, {
      $isOpen: isOpen,
      children: [/* @__PURE__ */jsx(TopCloseWrap, {
        onClick: handleClose,
        children: /* @__PURE__ */jsx(StyleableSvgImage, {
          src: ArrowDownIcon__default,
          width: 12,
          height: 12
        })
      }), /* @__PURE__ */jsx(ContentWrap, {
        children
      }), /* @__PURE__ */jsx(BottomCloseWrap, {
        children: /* @__PURE__ */jsx(Button, {
          full: true,
          variant: "tertiary",
          ...closeButtonProps,
          onClick: () => {
            closeButtonProps?.onClick?.();
            handleClose?.();
          },
          children: closeButtonProps?.value ?? "Close"
        })
      })]
    })]
  });
};
export { MobileModal };
//# sourceMappingURL=MobileModal.mjs.map
